import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

// Reuse this component for addressing account steps that
// need to be completed before viewing dashboard offers.
const DashboardUnauthorized = ({
  headingText,
  captionText,
  buttonLink,
  buttonText,
}) => (
  <div className='grey-section-full'>
    <div className='max-width-div-center'>
      <h1 className='_2nd-header-copy'>{headingText}</h1>
      <div className='text-block-4-copy'>{captionText}</div>
      <Link className='button-inline w-button' to={buttonLink}>
        {buttonText}
      </Link>
    </div>
  </div>
);

DashboardUnauthorized.propTypes = {
  headingText: PropTypes.string.isRequired,
  captionText: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonLink: PropTypes.string.isRequired,
};

export default connect()(DashboardUnauthorized);



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardUnauthorized.js